import { get } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import {
	checkData,
	getData,
	getFields,
} from '../../../../../screens/admin-screens/contributions/helper-functions/getters';
import { arrayToClass } from '../../../../../utilities/helper-fuctions';
import { Form } from '../../../../ui-components/form/form';
import { WidgetContributionPresenter } from '../../../shared/contributions/widget-contribution-presenter/widget-contribution-presenter';
import { customsDetailsFields } from './authority-helper';

const mapStateProps = (store: any) => ({
	user: store.user.user,
});

const mapDispatchProps = (dispatch: any) => ({});

class CustomsDetailsContributionComponent extends React.Component<any, any> {
	public state: any = {
		editable: [],
		rejected: [],
		isAdmin: get(this.props, 'user.roles', []).includes('ADMIN'),
		type: get(this.props.item, 'contribution.action'),
		buttonDisabled: false,
		editAll: false,
		title: null,
		field: null,
		isMapOpen: false,
	};

	public form = new Form({
		allowCrewFromCountries: this.props?.item?.allowCrewFromCountries,
		allowCrewFromRegions: this.props?.item?.allowCrewFromRegions,
		allowPassengersFromCountries:
			this.props?.item?.allowPassengersFromCountries,
		allowPassengersFromRegions:
			this.props?.item?.allowPassengersFromRegions,
		allowFlightsFromCountries: this.props?.item?.allowFlightsFromCountries,
		allowFlightsFromRegions: this.props?.item?.allowFlightsFromRegions,
		services: this.props?.item?.services,
		visaProcessed: this.props?.item?.visaProcessed,
	});

	public helper = new Form({
		allowCrewFromRegions: this.props?.item?.allowCrewFromRegions,
		allowFlightsFromRegions: this.props?.item?.allowFlightsFromRegions,
		allowPassengersFromRegions:
			this.props?.item?.allowPassengersFromRegions,
	});

	public renderEmpty(): React.ReactNode {
		return (
			<div className='display-flex justify-content-center align-items-center p-5 palette--bgc-neutral-2 border-radius-1 m-2'>
				<p className='palette--c-neutral-5 m-0'>Nothing changed.</p>
			</div>
		);
	}

	public render(): React.ReactNode {
		const customsDetailsList: any = getFields(
			this,
			customsDetailsFields(this)
		);

		if (!customsDetailsList || !customsDetailsList.length) {
			return this.renderEmpty();
		}

		return (
			<div className='ProviderContent w-100 pl-4 pr-0'>
				{customsDetailsList.map((item: any, index: number) => {
					return this.renderFields(item, index);
				})}
			</div>
		);
	}

	public renderFields(field, index): any {
		const wrapperClassName = arrayToClass([
			this.state.rejected.includes(field.type)
				? 'palette--bgc-neutral-3'
				: `palette--bgc-${
						this.state.type === 'UPDATE'
							? 'yellow-1'
							: this.state.type === 'CREATE'
							? 'green-1'
							: 'red-1'
				  }`,
			'border-radius-1 my-2 p-2',
			'display-flex align-items-center',
		]);

		const element = {
			type: field.type,
			content: this.getData(field.type),
			component: field.component,
		};

		return (
			<WidgetContributionPresenter
				isAdmin={this.state.isAdmin}
				key={index}
				title={field.title}
				fromValue={this.getOriginalData(field.type)}
				toValue={element}
				isEditable={this.state.editable.includes(field.type)}
				isRejected={this.state.rejected.includes(field.type)}
				handleEdit={(type) => this.handleEdit(type)}
				missEdit={(type) => this.handleMissEdit(type)}
				handleReject={(type) => this.handleReject(type)}
				missReject={(type) => this.handleMissReject(type)}
				className={wrapperClassName}
			/>
		);
	}

	public getField(isValue = false) {
		if (!!isValue) {
			return this.form.getValue(this.state?.field);
		}

		return this.form.getField(this.state.field);
	}

	public async onClick(title, field) {
		await this.setState({ title: title, field: field, isMapOpen: true });
	}

	public getOriginalData(field: any) {
		const value = this.props?.original?.[field];

		if (this.state.type === 'CREATE') {
			return null;
		}

		return getData(field, value, false);
	}

	public getData(field: any): any {
		const handling = this.form.generateJSON();
		const value = handling?.[field];

		if (this.state.type === 'DELETE') {
			return null;
		}

		return getData(field, value, true);
	}

	public async handleEdit(type: string = 'editAll'): Promise<void> {
		if (type === 'editAll') {
			const handlingArray =
				customsDetailsFields(this).map((item: any) => item.type) || [];
			await this.setState({ editable: handlingArray, editAll: true });
		}

		if (!this.state.editable.includes(type)) {
			await this.setState({ editable: [...this.state.editable, type] });
		}
	}

	public async handleMissEdit(type: string): Promise<void> {
		if (this.state.editable.includes(type)) {
			const editableArray = this.state.editable.filter(
				(item) => item !== type
			);
			await this.setState({ editable: editableArray });
		}
	}

	public handleReject(type: string): void {
		if (!this.state.rejected.includes(type)) {
			this.setState({ rejected: [...this.state.rejected, type] });
		}
	}

	public handleMissReject(type: string) {
		if (this.state.rejected.includes(type)) {
			const rejectedArray = this.state.rejected.filter(
				(item) => item !== type
			);
			this.setState({ rejected: rejectedArray });
		}
	}

	public clearForm(): void {
		this.form.clearForm();
	}

	public getContribution() {
		const obj = get(this.props, 'item');
		const formList = getFields(this, customsDetailsFields(this)) || [];
		const form = this.form.generateJSON();
		const changes = checkData(formList, obj, form);

		obj.contribution.rejectedChanges = this.state.rejected;
		obj.contribution.changes = changes;

		return obj || null;
	}
}

export const CustomsDetailsContribution: any = connect(
	mapStateProps,
	mapDispatchProps,
	null,
	{ forwardRef: true }
)(CustomsDetailsContributionComponent);
